import React from "react";
import { Container, Row } from "react-bootstrap";

//  Components
import MessagesPanel from "../../../components/MessagesPanel";

const MessagesTab = ({ messages }) => {
    const refresh = () => {
        window.location.reload();
    };

    return (
        <Container className="mb-3">
            <h4>
                Message Box{" "}
                <i
                    className="fas fa-redo-alt fs-5 text-danger"
                    onClick={refresh}
                ></i>
            </h4>
            <Row>
                
               <MessagesPanel messages={messages} />
            </Row>
        </Container>
    );
};

export default MessagesTab;
